import { useForm, DefaultValues } from 'react-hook-form';
import type { CountryCreate, CountryUpdate } from '../types/country.types';
import { useCallback } from 'react';

export interface UseCountryFormProps {
  defaultValues?: DefaultValues<CountryCreate | CountryUpdate>;
  onSubmit: (data: CountryCreate | CountryUpdate) => void;
}

export const useCountryForm = ({ defaultValues, onSubmit }: UseCountryFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm<CountryCreate | CountryUpdate>({
    defaultValues: defaultValues || {
      name: undefined,
      code: undefined,
      timezone: undefined,
    },
  });

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const submitHandler = useCallback(
    (data: CountryCreate | CountryUpdate) => {
      onSubmit(data);
    },
    [onSubmit]
  );

  const formSubmitHandler = useCallback(() => {
    return handleSubmit(submitHandler);
  }, [handleSubmit, submitHandler]);

  return {
    control,
    errors,
    resetForm,
    formSubmitHandler,
    reset,
    setError,
    setValue,
  };
};
